export default __webpack_public_path__ + "media/images/apple-touch-icon-152x152-precomposed-58e4c998.png";